import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltDivider } from '@cae/cobalt-react/components/divider';
import { CobaltIconCloseOutline } from '@cae/cobalt-react/icons/outline/CobaltIconCloseOutline';
import { CobaltIconWarningCircleSolid } from '@cae/cobalt-react/icons/solid/CobaltIconWarningCircleSolid';
import * as React from 'react';

import type { UploadedFileItemProps } from './UploadedFileItem.types';

import styles from './UploadedFileItem.module.css';

const UploadedFileItem = React.memo(
  ({
    fileItem,
    onRemove,
  }: Readonly<UploadedFileItemProps>): React.ReactElement => (
    <div
      className={`${styles.fileItem} elevation-04-floating`}
      data-testid="uploaded-file-row"
    >
      <div className={styles.fileItemHeader}>
        <div className={styles.fileItemHeaderName}>
          <span
            className={`body-02 ${styles.fileName}`}
            data-testid="uploaded-file-name"
          >
            {fileItem.file.name}
          </span>
        </div>
        <div className={styles.fileItemHeaderStatus}>
          {fileItem.invalid && (
            <div className={styles.fileItemStatusError} aria-live="assertive">
              <CobaltIconWarningCircleSolid
                className={styles.errorIcon}
                aria-label="Upload failed"
                data-testid="file-error-icon"
              />
            </div>
          )}
          <CobaltButton
            size="x-small"
            variant="ghost"
            onClick={onRemove}
            aria-label="Remove file"
            data-testid="remove-file-button"
          >
            <CobaltIconCloseOutline aria-hidden="true" />
          </CobaltButton>
        </div>
      </div>
      {fileItem.invalid && fileItem.invalidText && (
        <>
          <CobaltDivider className={styles.errorDivider} color="subtle" />
          <p
            className={`body-01 ${styles.errorText}`}
            data-testid="file-error-text"
          >
            {fileItem.invalidText}
          </p>
        </>
      )}
    </div>
  )
);

UploadedFileItem.displayName = 'UploadedFileItem';
export { UploadedFileItem };
